import NotFoundRedirect from './NotFoundRedirect';

export default NotFoundRedirect;
